import { createActionGroup, props } from "@ngrx/store";
import { Catalog, CatalogCreateRequest } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

// **************************************************************************
// CATALOG MANAGEMENT ACTIONS
// Admin CRUD operations for catalogs
// Note: Load actions are in entities/catalog/catalogs
// **************************************************************************
export const CatalogManagementActions = createActionGroup({
    source: "Contract Admin / Catalog Management",
    events: {
        "Create Catalog": props<{ request: CatalogCreateRequest }>(),
        "Create Catalog Success": props<{ catalog: Catalog; toastKey: string }>(),
        "Create Catalog Failure": props<{ error: AppError; toastKey: string }>(),
        "Delete Catalog": props<{ id: number }>(),
        "Delete Catalog Success": props<{ id: number; toastKey: string }>(),
        "Delete Catalog Failure": props<{ error: AppError; toastKey: string }>(),
        "Upload Catalog Image": props<{ catalogId: number; file: File }>(),
        "Upload Catalog Image Success": props<{ catalog: Catalog; toastKey: string }>(),
        "Upload Catalog Image Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
